<template>
	<article role="article" tabindex="0" class="small-12 medium-6 large-4 columns news-card">
		<link-base 
			v-if="pathObject" 
			:link="pathObject">
			<figure class="thumbnail-cover">
				<img 
					v-if="post.featured_image" 
					:src="post.featured_image.src" 
					v-bind:srcset="post.featured_image.srcset" 
					:alt="post.featured_image.alt" />
				<img 
					v-else 
					:src="require(`@/assets/img/news-placeholder.jpg`)" :alt="title" 
					/>
			</figure>
			<h4 v-if="title" v-html="title"></h4>
		</link-base>
		<link-arrow 
			v-if="pathObject" 
			:link="pathObject" 
			hideText="true"
			aria-label="Read more"
			>
		</link-arrow>
	</article>
</template>

<script>
export default {
	props: ['post'],
	computed: {
		title() {
			if (typeof this.post.title !== 'undefined') return this.post.title
			if (typeof this.post.name !== 'undefined') return this.post.name
			return this.post.text
		},
		path() {
			if (typeof this.post.link !== 'undefined') return this.post.link
			return this.post.path
		},
		pathObject() {
			return {
				text: this.title,
				path: this.path
			}
		}
	},
	components: {
		LinkArrow: () => import('dc-vue-default/src/components/global/ui/LinkArrow'),
		LinkBase: () => import('dc-vue-default/src/components/global/ui/LinkBase'),
	}
}
</script>